import axios from "axios";
import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import { Link } from "react-router-dom";
import Translate from "react-translate-component";
import Button from "../../../../UI/Button/Button";
import SectionHeadline from "../../../../UI/SectionHeadline/SectionHeadline";
import "../Blog/Blog.scss";
import BlogsItem from "./BlogsItem/BlogsItem";

class Blog extends React.Component {
  _isMounted = false;

  state = {
    isToggled: false,
    blogs: [],
  };

  componentDidMount() {
    this._isMounted = true;
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/rest/blogs`)
      .then((res) => {
        if (this._isMounted) {
          const blogs = res.data.items;
          this.setState({ blogs });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <section id={this.props.scrollAnchor} className="Blog">
        <div className="container">
          <div className="row">
            <div className="col-12 blog_headline">
              <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
                <SectionHeadline className="dark mt-5">
                  <Translate content="homepage.blog.headline" />
                </SectionHeadline>
              </ScrollAnimation>
            </div>
            <div className="blogs_space_placeholder">
              {this.state.blogs.slice(0, 3).map((item) => {
                return (
                  <BlogsItem
                    key={item.id}
                    slug={item.slug}
                    bootstrapClass="col-md-6 col-xl-4 mt-5"
                    externalUrl={item.externalUrl}
                    headline={item.title}
                    text={item.description}
                    img={item.headingImageURL}
                    date={item.publishedAt}
                  />
                );
              })}
            </div>
            {this.state.isToggled ? (
              <div className="blogs_space_placeholder">
                {this.state.blogs.slice(4, 8).map((item) => {
                  return (
                    <BlogsItem
                      key={item.id}
                      slug={item.slug}
                      secondRow
                      bootstrapClass="col-md-6 col-xl-4"
                      externalUrl={item.externalUrl}
                      headline={item.title}
                      text={item.description}
                      img={item.headingImageURL}
                      date={item.publishedAt}
                    />
                  );
                })}
              </div>
            ) : null}

            <div className="col-12 mt-5 mb-5 mb-md-0 text-center">
              <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
                <Link to="/clanok">
                  <Button
                    className="black is-bigger is-wider"
                    // onClick={() => this.setState({ isToggled: !toggled })}
                  >
                    {" "}
                    {this.state.isToggled ? (
                      <Translate content="homepage.blog.btn_menej" />
                    ) : (
                      <Translate content="homepage.blog.btn_viac" />
                    )}
                  </Button>
                </Link>
              </ScrollAnimation>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Blog;
 